var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMagnet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48.025 5.115-6.68 6.68a3.432 3.432 0 0 0 0 4.854l9.54 9.54a3.432 3.432 0 0 0 4.853 0l6.681-6.68a3.432 3.432 0 0 0 0-4.854l-9.54-9.54a3.432 3.432 0 0 0-4.854 0ZM80.51 37.598l-6.68 6.68a3.432 3.432 0 0 0 0 4.855l9.46 9.46a3.432 3.432 0 0 0 4.853 0l6.68-6.682a3.432 3.432 0 0 0 0-4.853l-9.459-9.46a3.432 3.432 0 0 0-4.854 0ZM46.14 71.914c-3.67 3.67-7.081 5.558-10.233 5.668-3.154.108-6.212-1.318-9.174-4.282-5.872-5.872-5.642-12.138.694-18.798L46.87 35.058a3.433 3.433 0 0 0 0-4.854l-9.54-9.54a3.433 3.433 0 0 0-4.854 0L13.319 39.822c-6.442 6.606-9.46 13.864-9.052 21.774.408 7.91 4.226 15.482 11.458 22.712 4.784 4.784 9.772 8.088 14.964 9.908 5.192 1.822 10.338 2.06 15.434.714 5.098-1.346 9.848-4.22 14.252-8.624l18.872-18.872a3.433 3.433 0 0 0 0-4.854l-9.458-9.458a3.433 3.433 0 0 0-4.854 0L46.143 71.914h-.002Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMagnet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/magnet.9025b43d075878589a0b71dcaac0e24a.svg";